import { toODataString } from '@progress/kendo-data-query';

export function convertDateFilter(originalODataString, fields = [], dataState = {}) {
    // console.log('dataState', dataState);
    // console.log('originalODataString', toODataString(dataState));
    var dataStateClone = JSON.parse(JSON.stringify(dataState));
    // console.log('render check', toODataString(dataStateClone));
    if (dataStateClone && dataStateClone.filter && dataStateClone.filter.filters) {
        var filters = dataStateClone.filter.filters;
        fields.forEach(function (field, i) {
            var new_filters = [];
            filters.forEach(function (filter) {

                var timestamp, start_date, end_date;

                if (filter.field == field && filter.value != null) {
                    timestamp = Date.parse(filter.value);
                    start_date = dateToString(timestamp - 86400000);
                    end_date = dateToString(timestamp);
                } else {
                    new_filters.push(filter);
                    return;
                }

                if (filter.operator == 'eq') {

                    new_filters.push({
                        logic: "and",
                        filters: [
                            { field: field, operator: 'gt', value: start_date },
                            { field: field, operator: 'lt', value: end_date }
                        ]
                    });
                } else if (filter.operator == 'neq') {

                    new_filters.push({
                        logic: "or",
                        filters: [
                            { field: field, operator: 'isnull', value: null},
                            { field: field, operator: 'lte', value: start_date },
                            { field: field, operator: 'gt', value: end_date }
                        ]
                    });

                } else if (filter.operator == 'lte' || filter.operator == 'lt') {

                    new_filters.push({filters: [{ field: field, operator: 'lte', value: filter.operator == 'lte' ? end_date : start_date }]});

                } else if (filter.operator == 'gte' || filter.operator == 'gt') {

                    new_filters.push({filters: [{ field: field, operator: 'gt', value: filter.operator == 'gte' ? start_date : end_date }]});

                } else if (filter.operator == 'isnull' || filter.operator == 'isnotnull') {

                    new_filters.push({ filters: [filter] });

                } else {
                    // console.log('WARNING: Unable to capture the Filter operator.');
                    if (filter.value != null) {
                        filter.value = new Date(filter.value);
                        new_filters.push({ filters: [filter] });
                    }
                }
            });
            filters = new_filters;
        });
    }
    if (dataStateClone.filter) {
        dataStateClone.filter.filters = filters;
    }
    // console.log('dataStateClone', dataStateClone);
    // console.log('revisedODataString', toODataString(dataStateClone));
    return toODataString(dataStateClone);
};

function isUnrelated(subsection, filters) {
    // console.log('checking for related actions=' + subsection);
    var stringNotFound = true;
    filters.forEach(function (filter) {
        if (subsection.indexOf(filter) != -1) {
            stringNotFound = false;
            // console.log('RELATED!=' + filter);
        }
    });
    return !stringNotFound;
}

function isEmpty(obj) {
  for(var prop in obj) {
    if(obj.hasOwnProperty(prop)) {
      return false;
    }
  }

  return JSON.stringify(obj) === JSON.stringify({});
}

function dateToString(timestamp) {
    var date = new Date(timestamp);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    return new Date(Date.parse(`${year}-${month}-${day} 23:59:59.999 GMT-0500`));
}
